/* Decoration only: no changes to the theme's menus, search or sticky-header logic. */
(() => {
  if (customElements.get('byards-autumn-leaves')) return;
  const preferenceKey = 'byards-autumn-leaves-paused';
  class ByardsAutumnLeaves extends HTMLElement {
    connectedCallback() {
      this.button = this.closest('store-header')?.querySelector('[data-autumn-toggle]');
      if (!this.button) return;
      let paused = false;
      try { paused = sessionStorage.getItem(preferenceKey) === 'true'; } catch (_) { /* Optional preference. */ }
      this.setPaused(paused);
      this.onToggle = () => {
        const next = this.dataset.paused !== 'true';
        this.setPaused(next);
        try { sessionStorage.setItem(preferenceKey, String(next)); } catch (_) { /* Still usable without storage. */ }
      };
      this.button.addEventListener('click', this.onToggle);
      this.dataset.motion = 'ready';
      this.button.hidden = false;
    }
    setPaused(paused) {
      this.dataset.paused = String(paused);
      this.button.dataset.paused = String(paused);
      const label = paused ? 'Resume autumn leaves' : 'Pause autumn leaves';
      this.button.setAttribute('aria-label', label);
      this.button.setAttribute('title', label);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onToggle);
    }
  }
  customElements.define('byards-autumn-leaves', ByardsAutumnLeaves);
})();
